import { useQuery } from "@tanstack/react-query"
import { TrainingGet } from "../app/models/Training"
import { digitalManagerApi } from "../services/api"

export function useTrainings() {
  const { data: trainingsList = [], isLoading: isLoadingTrainings } = useQuery({
    queryKey: ["trainings"],
    queryFn: () => digitalManagerApi.get<TrainingGet[]>(`/trainings`).then((r) => r.data),
  })

  return {
    trainingsList,
    isLoadingTrainings,
  }
}
